import { HashRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import PhotoGallery from "./pages/PhotoGallery";
import Portfolio from "./pages/Portfolio";
import "./App.css";
import AdminGallery from "./pages/AdminGallery";
import AdminLogin from "./pages/AdminLogin";
import ScrollToTop from "./utils/ScrollToTop";

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className={`navbar ${menuOpen ? "menu-active" : ""}`}>
      <div className="navbar-left">
        <Link to="/">
          <img src="logo.png" alt="Logo" className="navbar-logo animate-logo" />
        </Link>
      </div>

      <div className={`navbar-center ${menuOpen ? "active" : ""}`}>
        <Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>ABOUT</Link>
        <Link to="/portfolio" className="nav-link" onClick={() => setMenuOpen(false)}>PROJECTS</Link>
        <Link to="/gallery" className="nav-link" onClick={() => setMenuOpen(false)}>GALLERY</Link>
        <Link to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>CONTACT US</Link>
      </div>

      <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <div></div><div></div><div></div>
      </div>
    </nav>
  );
};

// ✅ Protected Route with redirect
const ProtectedRoute = ({ element: Component }) => {
  const token = sessionStorage.getItem("adminToken");
  return token ? <Component /> : <Navigate to="/login" replace />;
};

const App = () => (
  <>
    <Router>
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<PhotoGallery />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute element={AdminGallery} />} />
      </Routes>
    </Router>
    <Footer />
  </>
);

export default App;
